import { defineStore } from 'pinia'

export const usePrivacyPolicyModalStore = defineStore('privacyPolicyModal', {
  state: () => ({
    showModal: false
  }),
  actions: {
    openModal(): void {
      this.showModal = true
    },
    closeModal(): void {
      this.showModal = false
    }
  }
})
